/*=========================================================================================
  File Name: module-invoicetrial-state.js
  Description: InvoiceTrial Module State
  ----------------------------------------------------------------------------------------
  Project: MISA InvoiceBotTrials
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

export default {
	sizePdf: 0
};
